import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import valoracionGeriatricaVideo from "../../assets/bg/valoracion-geriatrica.webm";
import valoracionGeriatricaVideoMp4 from "../../assets/bg/valoracion-geriatrica.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario3PistaEvaluacionGeriatricos({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

    const { videoRef, canPlayWithSound } = useVideoWithSound({ 
        autoPlay: true, 
        volume: 0.8
    });
        
    const [canGoNext, setCanGoNext] = useState(false);

	const activeScenario = getScenarioNumByPath(location.pathname);
            
    useEffect(() => {
        const timer = setTimeout(() => setCanGoNext(true), 26000);
        return () => clearTimeout(timer);
    }, []);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0">
            <div className="row h-100 m-0">
                <div className="col-md-12 position-relative h-100 p-0 overflow-hidden ">
                    {/* VIDEO DE FONDO */}
                    <video
                        ref={videoRef}
                        className="bg-video-manuel"
                        autoPlay
                        playsInline
                        preload="auto"
                        muted={!canPlayWithSound}
                        onEnded={() => setCanGoNext(true)}
                        onError={() => setCanGoNext(true)}
                    >
                        <source src={valoracionGeriatricaVideoMp4}  type="video/mp4" />
                        <source src={valoracionGeriatricaVideo} type="video/webm" />
                    </video>

                    {/* CAPA DE CONTENIDO POR ENCIMA */}
                    <div className="content-overlay d-flex flex-column justify-content-between align-items-center h-75 px-5 position-relative mt-4">
                    <img
                        src={oncommit}
                        alt="decorativo"
                        style={{ maxWidth: "187px", left: "20px" }}
                        className="position-absolute"
                    />
                    <div className="recuadro recuadro-violet txtTexto1" style={{backgroundColor: "#FFFFFF99", marginLeft:"190px", width: "780px"}}>
                        <p>
                        En el hospital donde te encuentras, los pacientes con cáncer de próstata deben atravesar la Puerta del Tiempo para recibir una valoración geriátrica.<br/>La puerta solo se abre si cumples la edad mínima requerida.<br/><br/>"Solo quienes superan el umbral pueden avanzar"
                        </p>
                    </div>
                    <div className="d-flex align-items-center w-100 justify-content-end mb-5">
                        <div style={{backgroundColor: "#FFFFFF99", padding: "10px", borderRadius: "20px"}}>
                            <NextButton
                            navigateTo={ROUTES.SCENARIO3_EVALUACIONGERIATRICOS}
                            activeScenario={activeScenario}
                            color="violet"
                            canGoNext={canGoNext}
                            />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
    );
}

export default injectIntl(Scenario3PistaEvaluacionGeriatricos);
